import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var BrowserLockSvg = function BrowserLockSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.056 12.895h1.388v5.602H7.556v-5.602h1.388v-.642c0-.804.322-1.575.895-2.143A3.07 3.07 0 0 1 12 9.222c.81 0 1.588.32 2.16.888.574.568.896 1.339.896 2.143zm-1.482 0v-.642c0-.415-.166-.812-.461-1.104a1.58 1.58 0 0 0-2.226 0c-.295.292-.461.69-.461 1.104v.642zm-4.537 1.47v2.663h5.926v-2.663z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22 3H2v18h20zM3.481 6.673V4.47H20.52v2.204zm0 1.47V19.53h17.037V8.143z",
    clipRule: "evenodd"
  }));
};
export var BrowserLock = function BrowserLock(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: BrowserLockSvg
  }));
};